/** Shared 1px border for keyboard keys and adjacent above-keyboard footer controls. */
export const onscreenKeyboardKeyBorderClassName = "border border-foreground/15 dark:border-border";
